._GraphView_eiqrx_1 {
  height: 100%;
}